import { Spacing } from '@opallabs/gem'
import type { WithRequiredTheme, WithTheme } from '../../gem'

export type CheckboxProps = Readonly<
  WithTheme & {
    /**
     * @note This component intentionally does support an `ariaLabel` prop.
     *   Instead, you should have a `<label>` with descriptive text and a `for`
     *   attribute that’s passed to this component’s `htmlId` prop, or fall back
     *   to a non-`<label>` element with an `id` attribute that’s passed to this
     *   component’s `labelledbyId` prop. Using a `<label>` is best because it
     *   uses native semantics and provides the user with a physically-larger
     *   control to interact with.
     */
    ariaLabel?: never
    checked: boolean
    className?: string
    disabled?: boolean
    htmlId?: string
    labedlledbyId?: string
    onBlur?: React.FocusEventHandler<HTMLInputElement>
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    onFocus?: React.FocusEventHandler<HTMLInputElement>
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
    readOnly?: boolean
    size?: number
    tabIndex?: number
    value?: string
  }
>

/** For use in Storybook, which can’t extract destructured defaults within `forwardRef()` */
export const propDefaults = {
  checked: false,
  disabled: false,
  size: Spacing.M,
  tabIndex: 0,
} as const satisfies Omit<CheckboxProps, 'onChange'>

export type StyleProps = Readonly<
  WithRequiredTheme & Pick<CheckboxProps, 'size'>
>
